<template>
  <div style="background: #f5f5f5;background-image: url('../../../static/img/Background4.jpg');background-repeat: round;">
    <img src="../../../static/img/TopImage.jpg" class="home-banner"/>
    <div class="father_div_bg">
    <el-row :gutter="50" class="product-menu">
      <el-col :xs="24" :sm="24" :md="5" :lg="5" :xl="5" class="left">
        <div class="menu">
          <div class="biaoti">{{language == 'zh'?'新闻动态':'News'}}</div>
          <el-menu
              :default-active="menuPosition"
              class="el-menu-vertical-demo"
              @select="handleSelect"
            >
              <el-menu-item :index="i" v-for="(item,i) in menu" :key="i">
                <span slot="title">{{language == 'zh'?item.type:item.typeEn}}</span>
              </el-menu-item>
            </el-menu>
        </div>
        <div class="menu callus show_pc">
          <div class="text">
            {{language=='zh'?'联系我们':'Contact us'}}
          </div>
          <div class="tel">
           <img src="../../../static/img/50.png" /> {{contact.tel}}
          </div>
          <div class="email">
            <img src="../../../static/img/49.png" />{{contact.email}}
          </div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="19" :lg="19" :xl="19" class="right">
        <div class="news" @click="navto('/NewsDetail?id='+news.id)">
          <el-row :gutter="50" class="cur">
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" >
              <img :src="news.cover" />
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" >
              <div class="time">{{news.activityTime}}</div>
              <div class="title">{{language == 'zh'?news.title:news.titleEn}}</div>
              <div class="miaoshu">
                {{language == 'zh'?news.simple:news.simpleEn}}
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="newsitem">
            <el-row :gutter="25">
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" v-for="(item,i) in newslist" :key="i" class="newsbox">
                <div class="main" @click="navto('/NewsDetail?id='+item.id)">
                  <el-row :gutter="25">
                    <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10" >
                      <img :src="item.cover" />
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="14" :lg="14" :xl="14" >
                      <div class="time">{{item.activityTime}}</div>
                      <div class="title">{{language == 'zh'?item.title:item.titleEn}}</div>
                    </el-col>
                  </el-row>
                  <div class="miaoshu">
                        {{language == 'zh'?item.simple:item.simpleEn}}
                      </div>
                  </div>
              </el-col>
            </el-row>
          </div>
          
      </el-col>
      <div class="Mymenu callus show_phone">
          <div class="text">
            {{language=='zh'?'联系我们':'Contact us'}}
          </div>
          <div class="tel">
           <img src="../../../static/img/50.png" /> {{contact.tel}}
          </div>
          <div class="email">
            <img src="../../../static/img/49.png" />{{contact.email}}
          </div>
        </div>
    </el-row>
  </div>
  </div>
</template>

<script>
  export default {
    components: {

    },
    name: 'Product',
    props: {
      language: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        defaultProps: {
          children: 'child',
          label: 'name'
        },
        tabPosition: "left",
        menuPosition:0,
        currentPage:1,
        news:{},
        newslist:[],
        icon:"el-icon-plus",
        menu:[{
          name:"公司动态",
        },{
          name:"其他",
        },{
          name:"其他",
        },{
          name:"其他",
        },{
          name:"其他",
        }],
        contact:{}
      }
    },
    watch:{   //监听路由变化
      $route( to , from ){   
        this.getInfo()
        this.getInfo2()
      }
    },
    mounted() {
      this.getInfo()
      this.getInfo2()
    },
    methods: {
      navto(url) {
        this.$router.push(url);
      },
      getInfo() {
        this.$http
          .get("/hdbs/api/activity/type/list", {
            params:{
              parentType:'新闻动态'
            }
          })
          .then(
            function (response) {
              var status = response.data.code;
              if (status === 0) {
                this.menu = response.data.data.filter(x=>{return x.parentType == '新闻动态'});
                this.getInfo1()
              }
            }.bind(this)
          )
      },
      getInfo1() {
        this.menuPosition =localStorage.getItem("news_menu_position") ||0
        let type = this.menu[this.menuPosition].type
        // if(this.GetQueryString('type')){
        //   this.menuPosition = this.GetQueryString('type')
        //   type = this.menu[this.GetQueryString('type')].type
        // }
        this.$http
          .get("/hdbs/api/activity/list", {
            params:{
              page: this.currentPage,
              limit: 11,
              type:type
            }
          })
          .then(
            function (response) {
              var status = response.data.code;
              if (status === 0) {
                if(response.data.page.list.length > 0){
                  this.news = response.data.page.list[0]
                  this.newslist = (response.data.page.list).slice(1)
                }else{
                  this.news = {}
                  this.newslist = []
                }
                
              }
            }.bind(this)
          )
      },
      getInfo2() {
        this.$http
          .get("/hdbs/api/contacts/company", {

          })
          .then(
            function (response) {
              var status = response.data.code;
              if (status === 0) {
                this.contact = response.data.data[0]
              }
            }.bind(this)
          )
      },
       handleCurrentChange(val) {
         this.currentPage = val
        console.log(`当前页: ${val}`);
      },
      rowClick(row){
        this.$router.push('/ProductIntroduce?id='+row.id);
      },
      handleSelect(index,indexPath) {
        this.menuPosition = index;
        localStorage.setItem("news_menu_position", index)
        this.currentPage = 1
        this.getInfo1()
      },
    }
  }

</script>
<style lang="stylus" scoped>
.Mymenu{
  width: 100%;
  padding: 3.5rem 2rem;
  background: #fff;
  border-radius: 6px;
  font-size: 1.7rem;
  margin-bottom: 3rem;
  box-shadow: 0px 3px 12px rgba(0,0,0,0.12);
    .biaoti{
      color: var(--mainBlue);
      margin-bottom: 3rem;
      font-size: 2.7rem;
      margin-left: 2.5rem;
      font-family: Demibold;
    }
}
.show_pc {
  display: block;
}
.show_phone {
  display: none;
}
.el-menu {
  border-right: none;
  margin-left: 0.5rem;
}
.father_div_bg {
  padding:0 20rem;
  border-radius: 6px;
  height: 100%;
}
.el-menu-item {
  margin-bottom: 1rem;
  font-size: 1.7rem;
  font-family: Regular;
  color: var(--mainGary);
  height: auto;
  line-height: normal;
}

.el-menu-item.is-active {
  color: var(--mainBlue);
  background-color: #fff;
}

.el-menu-item:hover {
  outline: 0;
  background-color: #fff;
}
    .home-banner
      margin-top calc(-65px - 6vh)
      object-fit: cover;
      width: 100%;
    .callus
      padding: 10px;
      font-size: 14px;
      .text
        color: #024580;
        margin-bottom: 10px
        margin-left: 20px;
      .tel
        display: flex;
        align-items: center;
        margin-bottom: 10px
        img
          width 17px
          margin-right: 5px
      .email
        display: flex;
        align-items: center;
        img
          width 17px
          margin-right: 5px
    .product-menu
      margin:0!important
      .left
        padding-left 0!important
        margin-top: 6vh;
        .menu
          padding: 3.5rem 2rem;
          background: #fff;
          border-radius: 6px;
          font-size: 1.7rem;
          margin-bottom: 3rem;
          box-shadow: 0px 3px 12px rgba(0,0,0,0.12);
          .biaoti
            color: var(--mainBlue);
            margin-bottom: 3rem;
            font-size: 2.7rem;
            margin-left: 2.5rem;
            font-family: Demibold;
          .tree
            border-radius: 6px;
            padding: 1vw;
            font-family: 'Regular';
            /deep/.el-tree-node__content
              margin 10px 0
      .right
        margin-top: 6vh;
        background: #fff;
        border-radius: 6px;
        box-shadow: 0px 3px 12px rgba(0,0,0,0.12);
        margin-bottom: 6vh;
        .cur
          cursor pointer
        .news
          margin: 20px 0;
          background: #EFEFEF;
          border-radius: 6px;
          img
            margin: 25px
            border-radius: 6px;
          .time
            margin-top: 25px;
            margin-bottom: 10px;
            font-size: 1.7rem;
            color #9e9e9e
          .title  
            font-size: 2.1rem;
            color #606266
            font-family: Demibold;
          .miaoshu
            margin-top: 15rem;
            margin-right:2rem;
            color: #9E9E9E;
            font-size: 1.7rem;
            overflow hidden
            text-overflow ellipsis
            display -webkit-box
            -webkit-line-clamp 2
            -webkit-box-orient vertical
        .news:hover
          background: #fff;
          box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.12);
          .time
            color: #606266;
          .miaoshu
            color: #606266;
          .title
            color #024580
        .newsitem
          margin: 20px 0;
          .main
            background: #EFEFEF;
            border-radius: 6px;
            margin: 12.5px 0
            cursor: pointer;
            padding-bottom: 25px;
            img
              margin: 25px
              border-radius: 6px;
              width:100%;
              object-fit: cover;
            .time
              color: #9E9E9E;
              font-size:1.7rem;
              margin: 25px 25px 10px 25px
            .title
              margin: 0 25px;
              color #606266
              font-size:1.7rem;
              font-family: Demibold;
            .miaoshu
              margin: 0 25px;
              color: #9E9E9E;
              font-size:1.7rem;
              overflow hidden
              text-overflow ellipsis
              display -webkit-box
              -webkit-line-clamp 2
              -webkit-box-orient vertical
            .newsbox
              background: #EFEFEF;
        .main:hover
          background: #fff;
          box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.12);
          .time
            color: #606266;
          .miaoshu
            color: #606266;
          .title
            color #024580
.el-row{
  display: flex;
  flex-wrap: wrap;
}
@media screen and (max-width: 1400px) {
  .father_div_bg{
    padding:0 1rem;
  }
}
@media screen and (max-width: 1000px) {
  .product-menu .right .news img{
    margin:0;
  }
  .product-menu .right .newsitem .main img{
    margin:0;
  }
  .product-menu .right .news .miaoshu{
    margin-top:5rem;
    margin-bottom:5rem;
  }
  .show_pc {
    display: none;
  }

  .show_phone {
    display: block;
  }
  .product-menu .left{
    margin-top:0;
    padding-right: 0 !important;
  }
  .product-menu .right{
    margin-top:0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/News/News.vue